import { PriceList } from '@/modules/transactionV2/models/PositionItem'

export function getMatchingGraduatedPriceEntry(graduatedPriceList: PriceList[], amount: number): PriceList | null {
  return graduatedPriceList.reduce<PriceList | null>((best, item) => {
    if (item.quantity <= amount && (best === null || item.quantity > best.quantity)) {
      return item
    }
    return best
  }, null)
}
